import { RoomTask } from 'src/common/interfaces/tasks';

export interface RoomFooterProps {
  tasks?: RoomTask[];
  isSplitScreenOpen: boolean;
  currentTask?: RoomTask;
  roomCode: string;
}

export enum TaskProgressStatus {
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  NOT_STARTED = 'not-started',
}
